// extracted by mini-css-extract-plugin
export default {"novaTarefa":"forn_novaTarefa__F+4pj","inputContainer":"forn_inputContainer__esyXt"};